import { MrbBaseRouteStore } from "mrb/core";

class NakiMobileHomeScreenRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);
    }
}

export default NakiMobileHomeScreenRouteStore;
